<template>
    <div class="newsInformation">
        <!-- <div class="widthrules"> -->
            <!-- <div class="twoBoxs">
                <div class="big_title">
                    <div class="bigTitle">新闻资讯</div>
                    <div class="smallTitle">News</div>
                </div>
            </div> -->
            <!-- <div class="news_b_b" v-for="item in newsLists" :key="item.id">
                <div class="lefts">
                    <div class="oneBoxs">
                        <div class="title">
                            <div class="bigTitle">{{ item.name }}</div>
                            <div class="smallTitle">Company news</div>
                        </div>
                    </div>
                    <div class="moreInfo_icon" @click="classNewsList(item)">
                        <img src="../../../assets/img/images/more.png" style="width:110px;" alt="" />
                    </div>
                </div>
                <div class="rights">
                    <div class="left_boxs" v-for="ite in item.detailVOList.slice(0, 5)" :key="ite.id">
                        <div class="leftInfo">
                            <img :src="ite.pic" alt="" />
                        </div>
                        <div class="rightInfo">
                            <div class="tuwen" @click="article(ite.id)">
                                <img src="../../../assets/img/images/pile_icon.png" alt="" />{{ ite.title }}
                            </div>
                            <div class="date">{{ ite.relTime }}</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="banner_top">
                <img :src="this.sylbAddress" alt="" />
                <div class="content">
                    <div>新闻资讯</div>
                    <div>全国服务热线：010-81215833</div>
                </div>
            </div>
            <div class="topBox">
                <div v-for="item in newsLists" :key="item.id">
                    <!-- 新闻标题 -->
                    <div class="type_box">
                        <div class="box_title">{{ item.name }}</div>
                        <div class="more_btn" @click="more(item.id, item.name)">更多资讯</div>
                    </div>
                    <div class="news">
                        <!-- 左侧大新闻 -->
                        <div
                            class="newsBox"
                            v-for="ite in item.detailVOList.slice(0, 1)"
                            :key="ite.id"
                            @click="article(ite.id)"
                        >
                            <div class="imgBox">
                                <img class="img" :src="ite.pic" alt="" />
                            </div>
                            <div class="infoBox">
                                <div class="infoTitle">{{ ite.title }}</div>
                                <div class="infoText">{{ ite.brief }}</div>
                            </div>
                        </div>
                        <!-- 右侧新闻列表 -->
                        <div class="newsBox_two">
                            <div class="box_flex" v-for="itm in item.detailVOList.slice(1, 4)" :key="itm.id" @click="article(itm.id)">
                                <div class="left">
                                    <img class="img" :src="itm.pic" alt="" />
                                </div>
                                <div class="right">
                                    <div class="title">{{ itm.title }}</div>
                                    <div class="info">{{ itm.brief }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </div> -->
        <v-footer></v-footer>
    </div>
</template>

<script>
import vFooter from '../../common/footer.vue';
// import axios from 'axios';
import { getGWClassNewsInfor, gwGetSYLBList } from '@/api/index';
export default {
    name: 'newsInformation',
    components: {
        vFooter
    },
    data() {
        return {
            languageType: '1',
            sylbAddress: '',
            newsLists: [],
            reportsLists: [],
            newsListsInfo0: [],
        };
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.getGWClassNewsInfor();
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.getGWClassNewsInfor();
        });
        this.gwGetSYLBList();
    },
    mounted() {
        window.addEventListener('beforeunload', () => {
            sessionStorage.removeItem('position_news');
        });
        this.$nextTick(function() {
            this.scrollTos();
        }, 2000);
    },
    methods: {
        gwGetSYLBList() {
            let params = {
                language: this.languageType,
                type: '4'
            };
            gwGetSYLBList(params).then(res => {
                this.sylbAddress = res.obj[0].sylbAddress
            });
        },
        getGWClassNewsInfor() {
            let params = {
                language: this.languageType
            };
            getGWClassNewsInfor(params).then((res) => {
                // console.log('新闻资讯列表查询根据语言查询', res.obj);
                this.newsLists = res.obj;
            });
        },
        more(e, n) {
            this.$router.push({
                path: '/classNewsList',
                query: { params: e, name: n }
            });
        },
        scrollTos() {
            window.scrollTo({
                //滚动到元素位置
                top: sessionStorage.getItem('position_news'), //推荐使用，getBoundingClientRect 相对于当前视口的位置
                behavior: 'smooth' // 平滑滚动
            });
        },
        handleScroll() {
            var scrollTop = window.scrollY;
            sessionStorage.setItem('position_news', scrollTop);
        },
        article(e) {
            this.handleScroll();
            this.$router.push({
                path: '/articleInfo',
                query: { params: JSON.stringify({ id: e}) }
            });
        },
        classNewsList(e) {
            this.handleScroll();
            sessionStorage.removeItem('currentPage');
            this.$router.push({
                path: '/classNewsList',
                query: { params: JSON.stringify({ id: e.id,name:e.name}) }
            });
        }
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';
.banner_top {
    width: 100%;
    height: 4.95rem;
    margin: auto;
    // margin-bottom: -32px;
    overflow: hidden;
    position: relative;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
    .content {
        color: #fff;
        position: absolute;
        top: 1.875rem; /* 距离顶部10像素 */
        left: 2.75rem; /* 距离左侧10像素 */
        padding: .125rem;
    }
    .content > div:nth-child(1) {
        font-size: .75rem;
        font-weight: 500;
        margin-bottom: .3rem;
    }
    .content > div:nth-child(2) {
        font-size: .35rem;
        font-weight: 400;
    }
}
.topBox {
    padding: 0 3.25rem 1.25rem;
}
.type_box {
    display: flex;
    justify-content: space-between;
    margin: .625rem 0;
    .box_title {
        color: #023e7a;
        font-size: .5rem;
        font-weight: 600;
        display: block;
        width: 100%;
        height: 100%;
    }
}
.news {
    width: 100%;
    // height: 500px;
    display: flex;
    justify-content: space-between;
    .newsBox:hover .imgBox img{transform: scale(1.1);}
    .newsBox { // 大新闻
        // display: flex;
        width: 49%;
        height: 100%;
        text-decoration: none;
        background-color: #f8f8f8;
        // position: relative;
        cursor: pointer; 
        .imgBox {
            width: 100%;
            // height: 70%;
            height: 5rem;
            overflow: hidden;
            display: flex;
            .img {
                width: 100%;
                object-fit: cover;
                object-position: top;
                // max-width: none;
                // justify-content: center;
                // align-items: center;
                transform: scale(1);
                transition: all 0.5s;
            }
        }
        .infoBox {
            text-align: left;
            padding: .325rem .225rem;
            word-break: break-word;
            overflow: hidden;
            overflow-wrap: break-word;
            // height: 9.6em;
            // font-family: Microsoft YaHei, Arial, Helvetica, sans-serif;
            .infoTitle {
                font-weight: bold;
                font-size: .225rem;
                line-height: 1.625em;
                color: #333;
                overflow-x: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                margin-bottom: .025rem;
            }
            .infoText {
                font-size: .1969rem;
                line-height: 1.6875em;
                color: #666;
                // clear: both;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }
    }
    .newsBox_two { // 新闻列表
        width: 49%;
        display: flex;
        flex-direction: column;
        gap: .5375rem;
        .box_flex:hover .left img{transform: scale(1.1);}
        .box_flex {
            cursor: pointer;
            background-color: #f7f7f7;
            width: 100%;
            height: 1.875rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: .1875rem;
            box-sizing: border-box;
            .left {
                width: 30%;
                height: 100%;
                // height: 135px;
                overflow: hidden;
                margin: auto;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: top;
                    // object-fit: contain; // contain 保持原有比例；fill 默认 拉伸填充满
                    transition: all 0.6s ease-in-out;
                    // transform: scale(1);
                }
            }
            .right {
                width: 66%;
                margin: auto;
                .title {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: .225rem;
                    font-weight: 500;
                    color: #000;
                    margin-bottom: .1rem;
                }
                .info {
                    font-size: .175rem;
                    color: #3d3d3d;
                    -webkit-line-clamp: 3;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
.more_btn {
    width: 2.125rem;
    height: .5rem !important;
    line-height: .475rem !important;
    font-size: .25rem;
    border: .0125rem solid #111;
    text-align: center;
    // margin: 80px auto;
}
.more_btn:hover {
    background-color: #023e7a;
    cursor: pointer;
    color: #fff;
    border: .0125rem solid #023e7a;
}

/** ********************************************************************************************************************* */
.newsInformation {
//     background-color: #e1e1e1;
//     .banner_top {
//         width: 100%;
//         margin: auto;
//         margin-bottom: 50px;
//         img {
//             width: 100%;
//         }
//     }
    font-family: Source Han Sans;
}
.twoBoxs {
    width: 80%;
    margin: auto;
    // height:270px;
    // background-image: url(../../assets/img/news01.png);
    background-repeat: no-repeat;
    background-size: 62%;
    .big_title {
        width: 100%;
        margin-bottom: .625rem;
        // font-style:italic;
        z-index: 999;
        padding-top: .25rem;
        font-family: serif;
        font-weight: bold;
        .bigTitle {
            text-align: center;
            font-size: .75rem;
        }
        .smallTitle {
            font-size: .275rem;
            color: #2f2e2e;
            text-align: center;
        }
    }
}
.news_b_b {
    width: 80%;
    display: flex;
    margin: auto;
    margin-bottom: 1.5rem;
    background-size: 100% 100%;
    min-height: 6.875rem;
    background-image: url(../../../assets/img/images/newsInfoBg.png);
    .lefts {
        width: 30%;
    }
    .rights {
        width: 70%;
    }
}
.left_boxs {
    display: flex;
    padding: .125rem 0;
    border-bottom: .0125rem solid rgb(149, 149, 149);
    margin-bottom: .125rem;
    .leftInfo {
        width: 25%;
        height: 1.25rem;
        margin-right: .5rem;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: .125rem;
        }
    }
    .rightInfo {
        width: 75%;
        .tuwen {
            font-size: .25rem;
            padding-top: .25rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            img {
                width: .3125rem;
                vertical-align: middle;
                margin-right: 2%;
            }
        }
        .tuwen:hover {
            color: #409eff;
            cursor: pointer;
        }
        .date {
            font-size: .1875rem;
            margin-top: .125rem;
            margin-left: .4625rem;
        }
    }
}
.oneBoxs {
    .title {
        width: 2.5rem;
        margin: .625rem;
        .bigTitle {
            text-align: center;
            font-size: .5rem;
            font-weight: bold;
        }
        .smallTitle {
            font-size: .2rem;
            color: #2f2e2e;
            text-align: center;
        }
    }
}
.moreInfo_icon {
    text-align: center;
    margin-top: 80%;
}
.moreInfo_icon img:hover {
    cursor: pointer;
    width: 1.4375rem !important;
}
</style>
